export default __webpack_public_path__ + "ad858245897648655c4d897425247169.svg";